<template>
  <div id="hres6nu">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres6nuIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHres6nuSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :currentDtereq="dtereq"
            :currentNumseq="currentNumseq"
            :currentCodempid="codempid"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres6nu/mutation-types'
import detail from 'components/hres6nu/detail'
import moment from 'moment'

export default {
  name: 'hres6nu',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres6nuColumnsLabels()
    this.receivedHres6nuIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES6NU_INDEX_DISP,
      detailDisp: types.GET_HRES6NU_DETAIL_DISP,
      columns: types.GET_HRES6NU_COLUMNS,
      labels: types.GET_HRES6NU_LABELS,
      index: types.GET_HRES6NU_INDEX,
      indexSelected: types.GET_HRES6NU_INDEX_SELECTED,
      currentNumseq: types.GET_HRES6NU_CURRENT_NUMSEQ,
      detail: types.GET_HRES6NU_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      this.msgError = ''
      switch (event) {
        case 'edit':
          if (this.indexSelected.numseq) {
            let searchParams = {
              p_codempid: this.indexSelected.codempid,
              p_dtereq: this.indexSelected.dtereq,
              p_numseq: this.indexSelected.numseq,
              p_dtereqr: this.indexSelected.dtereqr
            }
            this.receivedHres6nuDetail(searchParams)
            this.toggle('detail')
          } else {
            this.msgError = 'Please select anyone row.'
          }
          break
        default:
          break
      }
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES6NU_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES6NU_PAGE,
      receivedHres6nuColumnsLabels: types.RECEIVED_HRES6NU_COLUMNS_LABELS,
      receivedHres6nuIndex: types.RECEIVED_HRES6NU_INDEX,
      receivedHres6nuCurrentNumseq: types.RECEIVED_HRES6NU_CURRENT_NUMSEQ,
      receivedHres6nuDetail: types.RECEIVED_HRES6NU_DETAIL,
      postHres6nuSendApprove: types.POST_HRES6NU_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?116f2d2a